const photos = [
  {
    alt: "réparation fenêtre Bischwiller",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/73131c375375b425d22a36886a752302.jpeg",
    prompt: "A professional technician repairing a window in a detached house in a small French town surrounded by gardens, close-up on hands and tools, warm natural lighting, clean interior background, professional repair service, soft warm tones, photorealistic, no people",
    seq: 1101,
    w: 800,
    h: 600,
  },
  {
    alt: "mécanisme fenêtre Bischwiller Bas-Rhin",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/be6c1f97d5ea7df8bcbfbe3be74c7a73.jpeg",
    prompt: "Close-up of a modern window mechanism being repaired with professional tools in a French suburban home, the window frame and hardware visible, clean interior, warm natural lighting, professional repair context, photorealistic, soft warm tones, no people",
    seq: 1102,
    w: 800,
    h: 600,
  },
  {
    alt: "technicien fenêtre Bischwiller",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/c450ec3e7af2cc1bbbd1474556446aa2.jpeg",
    prompt: "A professional technician in work clothes testing a repaired window in a French suburban house, the window slightly open showing clean hardware, warm natural lighting, clean interior, professional repair service, photorealistic, soft warm tones, no people",
    seq: 1103,
    w: 800,
    h: 600,
  },
];

export default function Gallery() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Galerie photos — Bischwiller
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl overflow-hidden border border-rose-200 bg-white"
            >
              <img
                src={
                  photo.src ||
                  `https://readdy.ai/api/search-image?query=${encodeURIComponent(photo.prompt)}&width=${photo.w}&height=${photo.h}&seq=${photo.seq}&orientation=landscape`
                }
                alt={photo.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}